import React from 'react';
import { connect } from 'react-redux';

import { ShowPasswordIcon, HidePasswordIcon } from './Styles/Icons';
import { RootContainer, LoginContainer, Title, DentiraLogo, FlexRow, Button, Waves, InputGroup, TextField, Password, InputAdornment, IconButton } from './Styles/Login';

import { loginUser } from '../../actions/loginUser';

class Login extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			username: '',
			password: '',
			showPassword: false,
			error: { main: '' },
		};
	}

	handleKeyPress = (e) => {
		if (e.keyCode === 13) {
			this.handleSubmit();
		}
	};

	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyPress, false);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyPress, false);
	}

	handleInput = (key, event, next = null) => {
		this.setState(
			{
				[key]: event.target.value,
				error: { ...this.state.error, [key]: '' },
			},
			next
		);
	};

	handleClickShowPassword = (event) => {
		let { showPassword } = this.state;

		this.setState({
			showPassword: !showPassword,
		});
	};

	handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	handleSubmit = (event) => {
		let { username, password } = this.state;

		let error = {};
		if (username === undefined || username === '') {
			error['username'] = 'Username cannot be empty.';
		}
		if (password === undefined || password === '') {
			error['password'] = 'Password cannot be empty.';
		}

		if (Object.keys(error).length) {
			this.setState({ error: error });
			return;
		}

		let credentials = {
			username: username,
			password: password,
		};

		this.props.loginUser(credentials);
	};

	render() {
		let { username, password, showPassword, error } = this.state;

		return (
			<RootContainer style={{ margin: '0' }}>
				<FlexRow style={{ height: '3.5rem', padding: '0 1rem' }}>
					<DentiraLogo />
				</FlexRow>

				<FlexRow style={{ justifyContent: 'center', minHeight: 'calc(100vh - 13.5rem)' }}>
					<LoginContainer>
						<Title>Login to continue</Title>

						<FlexRow>
							<InputGroup
								label='Username'
								error={error && error.username}
							>
								<TextField
									primary
									name='username'
									placeholder='Enter username'
									value={username}
									onChange={(e) => {
										this.handleInput('username', e);
									}}
									error={error && error.username}
								/>
							</InputGroup>
						</FlexRow>

						<FlexRow>
							<InputGroup
								label='Password'
								error={error && error.password}
							>
								<Password
									primary
									name='password'
									placeholder='Enter password'
									type={showPassword ? 'text' : 'password'}
									value={password}
									onChange={(e) => {
										this.handleInput('password', e);
									}}
									error={error && error.password}
									endAdornment={
										<InputAdornment>
											<IconButton
												aria-label='Toggle Password Visibility'
												onClick={(e) => {
													this.handleClickShowPassword(e);
												}}
												onMouseDown={(e) => {
													this.handleMouseDownPassword(e);
												}}
											>
												{showPassword ? <ShowPasswordIcon style={{ fontSize: '20px' }} /> : <HidePasswordIcon style={{ fontSize: '20px' }} />}
											</IconButton>
										</InputAdornment>
									}
								/>
							</InputGroup>
						</FlexRow>

						<FlexRow style={{ justifyContent: 'center', marginTop: '1rem' }}>
							<Button
								primary
								onClick={(e) => {
									this.handleSubmit(e);
								}}
							>
								Login
							</Button>
						</FlexRow>
					</LoginContainer>
				</FlexRow>

				<FlexRow style={{ height: '10rem' }}>
					<Waves />
				</FlexRow>
			</RootContainer>
		);
	}
}

export default connect(null, { loginUser })(Login);
